<template>
  <div class="tw:flex tw:flex-1 tw:justify-end">
    <BaseButton
      v-for="button in controlButtons"
      :key="button.key"
      circle
      color="ai"
      :data-testid="`${button.key}`"
      :disabled="button.disabled"
      :icon="button.icon"
      new-design
      new-icon
      @click="button.onClick"
    >
      <BaseStreemTooltip
        anchor="top middle"
        self="bottom middle"
      >
        {{ button.tooltip }}
      </BaseStreemTooltip>
    </BaseButton>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";

import { BaseButton, BaseStreemTooltip } from "shared/components/base";
import {
  type AIFeedbackEmit,
  type AIFeedbackProps,
  useAIFeedback,
} from "shared/modules/AI/composables/useAIFeedback";
import {
  type AISummary,
  useAIStore,
} from "shared/modules/AI/stores/useAIStore";

interface AISummaryStreamFeedbackProps extends AIFeedbackProps {
  streamId: number;
}

const props = defineProps<AISummaryStreamFeedbackProps>();
const emit = defineEmits<AIFeedbackEmit>();

const aiStore = useAIStore();
const { getAISummary } = aiStore;

const aiStreamSummary = computed<Required<AISummary>>(() =>
  getAISummary(props.streamId)
);

const { controlButtons, setFeedback } = useAIFeedback(props, { emit });

watch(
  aiStreamSummary,
  () => {
    if (aiStreamSummary.value.thumbsUp === null) return;

    setFeedback(
      aiStreamSummary.value.feedbackId,
      Boolean(aiStreamSummary.value.thumbsUp)
    );
  },
  { immediate: true }
);
</script>
